import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';

document.querySelectorAll('.hero-home-gallery').forEach(item => {
    new Swiper(item, {
        modules: [Autoplay],
        loop: true,
        autoHeight: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });
});

document.querySelectorAll('.team__slider').forEach(item => {
    const slider_el = item.querySelector('.swiper');
    const pagination_el = item.querySelector(".swiper-pagination");

    new Swiper(slider_el, {
        modules: [Pagination],
        pagination: {
            el: pagination_el,
        },
    });
});

document.querySelectorAll('.discover-farms-slider').forEach(item => {
    const parent_el = item.closest('.discover-farms__block');
    const pagination_el = parent_el.querySelector('.swiper-pagination');

    new Swiper(item, {
        modules: [Pagination, Autoplay],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        loop: true,
        pagination: {
            el: pagination_el,
            clickable: true,
        },
    });
});

document.querySelectorAll('.related-slider').forEach(item => {
    new Swiper(item, {
        spaceBetween: 8,
        slidesPerView: 1.295,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        autoHeight: true,
        breakpoints: {
            576: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 2,
                spaceBetween: 16,
            },
            992: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 3,
                spaceBetween: 16,
            }
        }
    });
});

document.querySelectorAll('.timeline-slider').forEach(item => {
    const parent_el = item.closest('.timeline');

    new Swiper(item, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.285,
        navigation: {
            nextEl: parent_el.querySelector(".swiper-button-next"),
            prevEl: parent_el.querySelector(".swiper-button-prev"),
        },
        pagination: {
            el: parent_el.querySelector('.timeline__pagination'),
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                const current_slide = current <= 9 ? '0' + current : current;
                const total_slides = total <= 9 ? '0' + total : total;

                return `
                    <span>${current_slide}</span>
                    <span>/${total_slides}</span>
                `;
            },
        },
        breakpoints: {
            576: {
                slidesPerView: 2.4,
            },
            768: {
                slidesPerView: 3.2,
            },
            992: {
                slidesPerView: 3.6,
            },
            1200: {
                slidesPerView: 4.1,
            },
            1400: {
                slidesPerView: 5.33,
            }
        }
    });
});

document.querySelectorAll('.more-products-slider').forEach(item => {
    new Swiper(item, {
        spaceBetween: 8,
        slidesPerView: 1.37,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        autoHeight: true,
        breakpoints: {
            576: {
                slidesOffsetBefore: 0,
                slidesPerView: 2.06,
            },
            768: {
                slidesOffsetBefore: 0,
                slidesPerView: 2.3,
                spaceBetween: 15,
            },
            1200: {
                slidesOffsetBefore: 0,
                slidesPerView: 2.6,
                spaceBetween: 15,
            },
            1400: {
                slidesOffsetBefore: 0,
                slidesPerView: 3.1,
                spaceBetween: 15,
            },
            1600: {
                slidesOffsetBefore: 0,
                spaceBetween: 17,
                slidesPerView: 3.73,
            }
        }
    });
});